/* eslint-disable react/jsx-no-undef */
import { AddIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";

type AddSectionType = {
  titleButton: string;
  children: any;
  scrollBehavior: any;
};

const AddSection = ({
  titleButton,
  children,
  scrollBehavior,
}: AddSectionType) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Box padding="30">
        <Button
          onClick={onOpen}
          leftIcon={<AddIcon />}
          colorScheme="blue"
          variant="solid"
          fontWeight="100"
          id="addButton"
        >
          {titleButton}
        </Button>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} scrollBehavior={scrollBehavior}>
        <ModalOverlay />
        <ModalContent
          paddingBottom="4"
          marginLeft="15px"
          marginRight="15px"
          marginTop="80px"
        >
          <ModalHeader>
            {titleButton}
            <Box
              fontSize="14px"
              color="#E53E3E"
              fontWeight="100"
              marginTop="10px"
            >
              (*) indica os campos obrigatórios
            </Box>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>{children}</ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddSection;
